import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { CATALOG } from "@/data";

const BasketContext = createContext(null);

export const MAX_QTY = 10;

export const BasketProvider = ({ children }) => {
  const [basket, setBasket] = useState(() => {
    try {
      return JSON.parse(window.localStorage.getItem("fp_basket")) || {};
    } catch (e) {
      return {};
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("fp_basket", JSON.stringify(basket));
    } catch (e) {
      /* storage unavailable */
    }
  }, [basket]);

  const bump = (name, d) =>
    setBasket((b) => {
      const next = Math.min(MAX_QTY, Math.max(0, (b[name] || 0) + d));
      const copy = { ...b };
      if (next === 0) delete copy[name];
      else copy[name] = next;
      return copy;
    });

  const clear = () => setBasket({});

  const [products, setProducts] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products`)
      .then((r) => r.json())
      .then((d) => setProducts(d.products || []))
      .catch(() => {});
  }, []);

  const priceOf = (name) => {
    const p = products && products.find((x) => x.name === name);
    return p ? p.price : CATALOG[name]?.price || 0;
  };

  const isAvailable = (name) => {
    const p = products && products.find((x) => x.name === name);
    return p ? p.available !== false : true;
  };

  const { count, total } = useMemo(() => {
    let c = 0;
    let t = 0;
    for (const [name, q] of Object.entries(basket)) {
      c += q;
      t += (products ? priceOf(name) : CATALOG[name]?.price || 0) * q;
    }
    return { count: c, total: t };
  }, [basket, products]);

  return (
    <BasketContext.Provider value={{ basket, bump, clear, count, total, products, priceOf, isAvailable }}>
      {children}
    </BasketContext.Provider>
  );
};

export const useBasket = () => useContext(BasketContext);
